import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DominioDto } from '../../../dto/justino/dominio.dto';

@Component({
  selector: 'app-modal-selec-ele',
  templateUrl: './modal-selec-ele.component.html',
  styleUrl: './modal-selec-ele.component.scss',
})
export class ModalSelecEleComponent implements OnInit {
  @ViewChild('modalSeleccionElemento')
  modalSeleccionElemento!: ElementRef;

  domFormGroup!: FormGroup;

  elementos: DominioDto[] = [];
  @Output() elementoEmitter = new EventEmitter<string>();
  fieldsElementos: any[] = [
    {
      name: 'elemento',
      label: 'Elemento',
      type: 'select',
      required: true,
      width: '12',
      visible: true,
      errorMessages: { required: 'El elemento es requerido' },
    },
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.creacionFormulario();
  }

  async creacionFormulario() {
    const formControls: any = {};
    this.fieldsElementos.forEach(field => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      formControls[field.name] = [null, validators];
    });
    this.domFormGroup = this.fb.group(formControls);
  }

  onSubmitSeleccionarElemento() {
    const elementoSeleccionado = this.domFormGroup.get('elemento')?.value;
    this.elementoEmitter.emit(elementoSeleccionado);
    this.domFormGroup.reset();
    this.modalSeleccionElemento.nativeElement.click();
  }

  abrirModalRelacionar(elementos: DominioDto[]) {
    this.elementos = elementos;
    this.creacionFormulario();
    this.modalSeleccionElemento.nativeElement.click();
  }

  abrirCerrarModal() {
    this.modalSeleccionElemento.nativeElement.click();
  }
}
